/** Helpers for monitoring published-content manual uploads (S3 key + mime → extension). */

export function extensionForImageMime(mime: string): string {
  switch (mime.toLowerCase()) {
    case 'image/png':
      return 'png';
    case 'image/webp':
      return 'webp';
    case 'image/gif':
      return 'gif';
    case 'image/bmp':
      return 'bmp';
    default:
      return 'jpg';
  }
}

export function extensionForVideoMime(mime: string): string {
  const lower = mime.toLowerCase();
  if (lower === 'video/webm') {
    return 'webm';
  }
  if (lower === 'video/quicktime') {
    return 'mov';
  }
  return 'mp4';
}

export function buildMonitoringImageKey(
  publishedContentId: string,
  slideIndex1Based: number,
  mime: string,
): string {
  return `${publishedContentId}_slide_${slideIndex1Based}.${extensionForImageMime(mime)}`;
}

export function buildMonitoringVideoKey(publishedContentId: string, mime: string): string {
  return `monitoring-published-content/${publishedContentId}.${extensionForVideoMime(mime)}`;
}
